import React from 'react';
import {
  Descriptions,
  DescriptionsProps,
  List,
  Typography,
  notification,
} from 'antd';
import repoProjectStore from '../store/RepoProject';
import dataGripStore from 'ts/store/DataGrip';
import { formatDate } from '../helpers/formatDate';

interface IProject {
  id: number;
  repository_id: number;
  name: string;
  offline?: boolean;
  disabled?: boolean;
  last_processed_date?: Date;
  last_duration?: number;
  last_error?: string;
  last_commit_hash?: string;
  last_commit_date?: Date;
}

interface IProps {
  project: IProject;
}

function ListItem({ project }: IProps) {
  
  async function handleClick(e?: React.MouseEvent<HTMLElement, MouseEvent>) {
    if (e) e.preventDefault();
    dataGripStore.setProjectName(project.name);
    const [logData, error] = await repoProjectStore.getLogById(project.id);
    if (error) {
      notification.error({
        message: 'Oops! Failed to fetch project logs! Please try again!',
      });
    } else {
      // dataGripStore.asyncSetCommits(logData.map((element: any) => JSON.stringify(element)));
      dataGripStore.asyncSetCommits(logData);
      // add this code after logData on 19th line to prevent error
      // .map((element: any) => JSON.stringify(element))
    }
  }

  const items: DescriptionsProps['items'] = [
    {
      key: 'last_processed_date',
      label: 'Last processed date',
      children: (
        <Typography.Text strong>
          {formatDate(project.last_processed_date)}
        </Typography.Text>
      ),
    },
    // ToDo: return disabled & offline fields when functionality is implemented
    // {
    //   key: '2',
    //   label: 'Disabled',
    //   children: (
    //     <Typography.Text strong>
    //       {project.disabled ? 'true' : 'false'}
    //     </Typography.Text>
    //   ),
    // },
    // {
    //   key: '3',
    //   label: 'Offline',
    //   children: (
    //     <Typography.Text strong>
    //       {project.offline ? 'true' : 'false'}
    //     </Typography.Text>
    //   ),
    // },
    {
      key: 'last_commit_date',
      label: 'Last commit date',
      children: (
        <Typography.Text strong>
          {formatDate(project.last_commit_date)}
        </Typography.Text>
      ),
    },
    {
      key: 'last_commit_hash',
      label: 'Last commit hash',
      children: (
        <Typography.Text strong>
          {project.last_commit_hash ? project.last_commit_hash.slice(0, 8) : ''}
        </Typography.Text>
      ),
    },
    {
      key: 'last_error',
      label: 'Last error',
      children: (
        <Typography.Paragraph
          type={project.last_error ? 'danger' : 'success'}
          ellipsis={{
            rows: 2,
            expandable: 'collapsible',
            onExpand: (e: any) => {
              e.stopPropagation();
            }
          }}
        >
          {project.last_error ?? 'No Errors'}
        </Typography.Paragraph>
      )
    },
  ];

  return (
    <List.Item key={project.id}>
      <Descriptions
        bordered
        size="small"
        layout="vertical"
        items={items}
        title={
          <Typography.Link
          style={{ fontWeight: 'bold', fontSize: 16 }}
          onClick={handleClick}
          >
            {project.name}
          </Typography.Link>
        }
        style={{ width: '100%' }}
        // ToDo: make columns number
        // column={15}
        column={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5, xxl: 6 }}
      />
    </List.Item>
  );
}

export default ListItem;
